import { loadShared } from './dashboardCache';

// What a click on a lead count opens: the leads behind the number (see lead_details.controller.js on the server).
// One place builds the URL, so the page that PREFETCHES on hover and the popup that LOADS on click use the very same
// address - and so share the very same remembered answer (dashboardCache.js).
export const KIND_LABEL = { assigned: 'Leads assigned', assessed: 'Leads assessed', admitted: 'Admissions' };

export const leadDetailsUrl = ({ metric, kind, userId, category, month }) => {
  const params = new URLSearchParams({ metric, kind, userId: String(userId), category, month: month.format('YYYY-MM-DD') });
  return `warning-dashboard/lead-details?${params.toString()}`;
};

// Warm the remembered answer (no UI): called when the pointer rests on a count, so by the click it is usually there.
export const prefetchLeadDetails = (request) => {
  loadShared(leadDetailsUrl(request)).catch(() => {});
};
